<template lang="pug">
.styled-listing
	.styled-listing__media
		img(:src="listing.img")
	.styled-listing__content
		h3.styled-listing__heading {{ listing.heading }}
		p.styled-listing__metadata 
			i(v-if="listing.iconClass && listing.iconClass !== ''", :class="listing.iconClass")
			span(v-for="metadata in listing.metadata") {{ metadata }}
		p.styled-listing__description {{ listing.description }}
		a(:href="listing.linkPath").btn Read Article
</template>

<script>
export default {
	name: "StyledListing",
	props: {
		listing: Object
	},
	data() {
		return {

		}
	},
	computed: {
		
	}
	
}
</script>

<style lang="scss" scoped>
.styled-listing {
	margin-bottom: 5rem;
	display: flex;
	@include mqdn(lg) {
		flex-direction: column;
	}
	@include mqdn(md) {
		margin-bottom: 2.75rem;
	}
	&__media,
	&__content {
		flex: 0 0 50%;
	}
	&__media {
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			margin: 0;
			vertical-align: top;
		}
	}
	&__content {
		background: $white;
		padding: 3.25rem 3.25rem 3.5rem 5rem;
		@include mqdn(md) {
			padding: 1rem 1rem 2rem;
		}
	}
	&__heading {
		@include fluid(font-size, 1.875rem, 2.5rem);
		margin-bottom: 0.5rem;
	}
	&__metadata {
		font-family: $fontFamilyHeadings;
		color: #5f6e7d;
		margin-bottom: 1rem;
		@include fluid(font-size, 0.875rem, 1rem);
		i {
			margin-right: 0.5rem;
		}
		span {
			&:not(:last-child) {
				&::after {
					content: "|";
					margin: 0 0.75rem;
				}
			}
		}
	}
	&__description {
		@include fluid(font-size, 16px, 18px, 320px, 1400px);
		@include fluid(line-height, 24px, 28px);
	}
}
</style>